import React from "react"
import Layout from "../components/Layout/layout"
import PropTypes from "prop-types"
import SEO from "../components/seo"
import ListActualites from "../components/Home/Actualites/actualites"
import ContenuLibre from "../components/ContenuLibre/contenu-libre"
import CarnetAdresse from "../components/Home/CarnetAdresse/carnet-adresse"
import AgendaEvenements from "../components/Home/Agenda/agenda"
import ListNePasManquer from "../components/Home/NePasManquer/ne-pas-manquer"
import ListPartenaires from "../components/Home/Partenaires/partenaires"
import AccesDirects from "../components/Home/AccesDirect/acces-direct"
import {
  sectionFirst,
  sectionSecond,
  sectionThird,
  sectionNePasManquer,
  sectionPartenaires,
  sectionAccesDirect,
} from "../styles/index.module.scss"
import { useBuildData } from "../hooks/use-build-data"
import BandeauAlert from "../components/BandeauAlert/bandeau-alert"
import NotificationPopup from "../components/NotificationPopup/notification-popup"
import styled from "styled-components"

const IndexPage = ({ location }) => {
  const buildInfos = useBuildData().site_settings
  return (
    <Layout isIndex={true} message={buildInfos.website_name}>
      <SEO
        description={buildInfos.seo.description_tag}
        title={buildInfos.seo.title_tag || "Accueil"}
      />
      <BandeauAlert alertContent={buildInfos.alert_message.value} />
      <NotificationPopup
        popupContent={buildInfos.notification_popup.value}
        location={location}
      />
      <div className={sectionFirst}>
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_1" />
        <ListActualites />
      </div>
      <ColoredDiv className={sectionAccesDirect}>
        <AccesDirects />
      </ColoredDiv>
      <div className={sectionSecond}>
        <CarnetAdresse />
        <AgendaEvenements />
      </div>
      <ColoredDiv className={sectionNePasManquer}>
        <ListNePasManquer />
      </ColoredDiv>
      <div className={sectionThird}>
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_2" />
        <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_3" />
      </div>
      <div className={sectionPartenaires}>
        <ListPartenaires />
      </div>
    </Layout>
  )
}

const ColoredDiv = styled.div`
  &:empty {
    height: 0;
  }
  background-color: ${(props) => props.theme.c_color_gradients.c_dark};
`

//-----------------------Prop-Types---------------------------//

IndexPage.propTypes = {
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default IndexPage
